/* v2-gallery-dots.js - moved out of the page into a cached asset (was inline).
   Runs once per page; in the theme editor it re-runs when a section reloads,
   exactly as the inline version did. */
(function () {
if (window.__v2Asset_v2_gallery_dots_js) return;
window.__v2Asset_v2_gallery_dots_js = 1;
function v2run() {
(function () {
  'use strict';

  var cfg = document.querySelector('[data-v2-dots-cfg]');
  var STYLE = (cfg && cfg.getAttribute('data-style')) || 'rings';
  var GAP   = parseFloat(cfg && cfg.getAttribute('data-gap'));
  if (isNaN(GAP)) GAP = 16;
  var SPACE = parseFloat(cfg && cfg.getAttribute('data-space'));
  if (isNaN(SPACE)) SPACE = 12;
  var STACK = parseFloat(cfg && cfg.getAttribute('data-stack'));
  if (isNaN(STACK)) STACK = 14;
  var MQ    = '(min-width: 750px)';

  /* ---------------------------------------------------------------- *
   * One gallery.                                                      *
   * ---------------------------------------------------------------- */
  function attach(gallery) {
    if (gallery.getAttribute('data-v2-dots')) return true;

    /* The gallery snippet is also rendered a second time with is_duplicate,
       which suffixes every id with -duplicate. That copy is scaffolding for
       the media modal, not the page. Leave it alone. */
    if ((gallery.id || '').indexOf('-duplicate') !== -1) return true;

    var rail = gallery.querySelector('[id^="GalleryThumbnails"]')
            || gallery.querySelector('.thumbnail-slider');

    /* How many photos can a shopper see at once? A thumbnail layout shows
       exactly one and swaps it; the stacked layout shows them all down the
       column. That one count decides everything below - whether a dot
       CHANGES the photo or SCROLLS to it. */
    function mediaItems() {
      var m = gallery.querySelectorAll('.product__media-item'), out = [], i;
      for (i = 0; i < m.length; i++) {
        if (m[i].offsetParent !== null || m[i].getClientRects().length) out.push(m[i]);
      }
      return out;
    }
    var MODE = mediaItems().length > 1 ? 'scroll' : 'swap';
    if (MODE === 'swap' && !rail) return true;   /* single photo - nothing to do */

    /* Which thumbnails does a shopper actually see right now? With "hide
       other variants' media" on, the snippet stamps thumbnail-list_item--variant
       on some of them and the theme hides those. Ask the browser instead of
       reading class names, and do it BEFORE anything gets hidden - after that
       the answer is always "none". */
    var visible = {}, shown = 0, partial = false;
    if (rail) {
      var all = rail.querySelectorAll('.thumbnail-list__item');
      if (!all.length) all = rail.querySelectorAll('li');
      for (var k = 0; k < all.length; k++) {
        if (all[k].offsetParent !== null || all[k].getClientRects().length) {
          visible[all[k].getAttribute('data-target') || ('i' + k)] = 1;
          shown++;
        }
      }
      partial = shown > 0 && shown < all.length;
    }

    /* Never cache the button list. Dawn's setActiveMedia(id, true) PREPENDS
       the newly featured thumbnail, so a variant change genuinely reorders
       this list. Re-reading it on every click and every sync means dot N
       always drives whatever currently sits at position N. */
    function thumbs() {
      if (!rail) return [];
      var items = rail.querySelectorAll('.thumbnail-list__item');
      if (!items.length) items = rail.querySelectorAll('li');
      var out = [], i, b, key;
      for (i = 0; i < items.length; i++) {
        key = items[i].getAttribute('data-target') || ('i' + i);
        if (shown && !visible[key]) continue;
        b = items[i].querySelector('button');
        if (b) out.push(b);
      }
      return out;
    }

    var first = MODE === 'scroll' ? mediaItems() : thumbs();
    if (first.length < 2) return true;    /* one image - a dot rail is noise */

    var dotrail = document.createElement('div');
    dotrail.className = 'v2-dotrail';
    dotrail.setAttribute('data-style', STYLE);
    dotrail.style.gap = SPACE + 'px';
    dotrail.setAttribute('role', 'group');
    dotrail.setAttribute('aria-label', 'Product image navigation');

    var dots = [];
    first.forEach(function (btn, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'v2-dot';
      d.setAttribute('data-i', i);
      d.setAttribute('aria-label', MODE === 'scroll'
        ? ('Go to image ' + (i + 1) + ' of ' + first.length)
        : (btn.getAttribute('aria-label') || ('Load image ' + (i + 1) + ' in gallery view')));

      d.addEventListener('click', function (e) {
        e.preventDefault();
        if (MODE === 'scroll') {
          var m = mediaItems();
          if (m[i]) m[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var list = thumbs();
        if (list[i]) list[i].click();
      });

      d.addEventListener('keydown', function (e) {
        var to = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') to = dots[i + 1];
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') to = dots[i - 1];
        else if (e.key === 'Home') to = dots[0];
        else if (e.key === 'End') to = dots[dots.length - 1];
        else return;
        if (!to) return;
        e.preventDefault();
        to.focus();
        to.click();
      });

      dots.push(d);
      dotrail.appendChild(d);
    });

    /* Mirror Dawn's own active marker rather than tracking state ourselves.
       This is what makes a swatch change light the right dot for free: Dawn
       moves aria-current, we follow. */
    /* Centre the rail on the photo, not on the gallery box. Re-measured on
       every media change because a portrait shot and a square one do not
       share a midpoint. */
    function photo() {
      return gallery.querySelector('.product__media-item.is-active .product__media')
          || gallery.querySelector('.product__media-item.is-active .product-media-container')
          || gallery.querySelector('.product__media')
          || gallery.querySelector('[id^="GalleryViewer"]');
    }
    function place() {
      var a = photo();
      if (!a) return;
      var b = a.getBoundingClientRect();
      if (!b.height) return;

      var buy = document.querySelector('[data-v2-groups]')
             || document.querySelector('.product__info-container')
             || document.querySelector('.product__info-wrapper');
      if (!buy) return;
      var buyLeft = buy.getBoundingClientRect().left;
      var w = dotrail.offsetWidth || 24;
      if (!(buyLeft - b.right > w + 4)) return;   /* gutter too tight - leave it */

      /* GAP is measured to the visible mark, not to the button - the button
         is 24px for the sake of a fair tap target and the ring inside it is
         8px, so two thirds of it is empty space. */
      var vis = 8;
      try { vis = parseFloat(getComputedStyle(dots[0], '::before').width) || 8; } catch (e) {}
      var inset = Math.max(0, (w - vis) / 2);
      var left = b.right + GAP - inset;
      left = Math.max(b.right, Math.min(left, buyLeft - w - 4));  /* never overlap */

      if (MODE === 'scroll') {
        /* Fixed to the viewport, so the browser holds it still while you
           scroll. It used to be absolutely positioned with its top rewritten
           on every scroll frame - a layout write in between the layout reads
           sync() needs, which is what made the dots lag behind the page and
           swim. Now nothing is written while scrolling at all: left is set
           here, on resize, and top:50% is plain CSS. */
        dotrail.style.left = Math.round(left) + 'px';
        dotrail.style.right = 'auto';
        dotrail.style.top = '';
        return;
      }

      var g = gallery.getBoundingClientRect();
      dotrail.style.top = (b.top - g.top + b.height / 2) + 'px';
      var R = g.right - (left + w);
      if (isFinite(R)) dotrail.style.right = R + 'px';
    }

    var queued = false;
    function sync() {
      queued = false;
      if (MODE !== 'scroll') place();
      var i, on = -1;

      if (MODE === 'scroll') {
        /* Whichever photo is nearest the middle of the screen is the one
           being looked at. No aria-current to mirror here - in a stacked
           gallery the theme has no notion of a current image. */
        var m = mediaItems(), mid = window.innerHeight / 2, best = Infinity, r, d;
        var top = Infinity, bot = -Infinity;
        for (i = 0; i < m.length && i < dots.length; i++) {
          r = m[i].getBoundingClientRect();
          if (r.top < top) top = r.top;
          if (r.bottom > bot) bot = r.bottom;
          d = Math.abs((r.top + r.bottom) / 2 - mid);
          if (d < best) { best = d; on = i; }
        }
        /* Fade out once the photos no longer straddle the middle of the
           screen, so the rail is not left hanging beside the rest of the page. */
        if (mid > top && mid < bot) dotrail.removeAttribute('data-away');
        else dotrail.setAttribute('data-away', '');
      } else {
        var list = thumbs();
        for (i = 0; i < dots.length; i++) {
          if (list[i] && list[i].hasAttribute('aria-current')) { on = i; break; }
        }
      }
      /* Nothing matched. With a partial set that means the newly featured
         media is one of the hidden variant images, so the honest answer is
         to leave the last lit dot alone rather than snap to the first. */
      if (on === -1) {
        if (partial) return;
        on = 0;
      }
      for (i = 0; i < dots.length; i++) {
        if (i === on) dots[i].setAttribute('aria-current', 'true');
        else dots[i].removeAttribute('aria-current');
      }
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sync);
    }
    /* Two different jobs, deliberately kept apart. queue() runs on SCROLL and
       only reads. relayout() runs when the geometry actually changed - images
       arriving, a resize - and is the only thing allowed to write position.
       Mixing them is what made the rail lag behind the page. */
    function relayout() { place(); queue(); }

    if (rail) {
      new MutationObserver(queue).observe(rail, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['aria-current']
      });
    }
    if (MODE === 'scroll') {
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', relayout);
    }

    /* The rail is absolutely positioned, so the gallery has to be its
       containing block - but only if nothing else already made it one.
       .product__column-sticky is position:sticky with top:3rem, and sticky
       is already a containing block, so relative would gain us nothing and
       cost her the sticky gallery plus a 3rem drop. */
    if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';

    gallery.appendChild(dotrail);
    gallery.setAttribute('data-v2-dots', 'on');
    if (MODE === 'scroll') {
      gallery.setAttribute('data-v2-mode', 'scroll');
      gallery.style.setProperty('--v2-stack-gap', STACK + 'px');
    }
    unclip(gallery);
    sync();

    /* Images arrive after the markup does, and the column reflows on resize.
       These must run the FULL sync, not just place(): before the photos have
       loaded every item is a few pixels tall and stacked at the top, so the
       one nearest the middle of the screen is the LAST one. Repositioning the
       rail without re-picking left that wrong guess showing until the first
       scroll. */
    try { new ResizeObserver(relayout).observe(gallery); } catch (err) {
      window.addEventListener('resize', relayout);
    }
    window.addEventListener('load', relayout);
    return true;
  }

  /* ---------------------------------------------------------------- *
   * Mobile: a scroll line instead of a thumbnail row.                 *
   * Built at every width and hidden by CSS above 750, so crossing the *
   * breakpoint needs no teardown.                                     *
   * ---------------------------------------------------------------- */
  function progress(gallery) {
    if (gallery.getAttribute('data-v2-progress')) return true;
    /* 'onphoto' lays the scroll line over the bottom edge of the picture, in
       plum, so it costs no height. Anything else leaves it where it was: in
       the flow under the photos, in black, the width of the gallery column. */
    var ONPHOTO = (cfg && cfg.getAttribute('data-progress')) === 'onphoto';
    if ((gallery.id || '').indexOf('-duplicate') !== -1) return true;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var slider = gallery.querySelector('[id^="Slider-Gallery"]');
    if (!viewer || !slider) return false;

    var items = gallery.querySelectorAll('.product__media-item');
    if (items.length < 2) return true;

    var track = document.createElement('div');
    track.className = 'v2-progress';
    track.setAttribute('aria-hidden', 'true');
    var seg = document.createElement('i');
    track.appendChild(seg);
    viewer.appendChild(track);
    gallery.setAttribute('data-v2-progress', 'on');

    /* The track is a child of the viewer, so it spans the whole gallery column
       - and on a phone the picture inside is inset from that column by the
       slider's own padding. Left alone, the filled segment sticks out past the
       photo on the left, which reads as a stray rule rather than a progress
       line. Measured against the scroll container, which is the frame every
       photo fills and does not move when the strip is swiped. */
    /* The track is positioned against the viewer, so its offsets are measured
       from the viewer's own box out to the picture's edges. The scroll
       container is used as the picture's frame because an individual photo
       moves when the strip is swiped, and its box would drag the line with
       it. */
    function fitTrack() {
      if (!ONPHOTO) return;
      var frame = slider.getBoundingClientRect();
      var host = viewer.getBoundingClientRect();
      if (frame.width < 40 || host.width < 40) return;
      /* Sit on the PHOTO's bottom edge, not the viewer's. The viewer runs a
         few pixels past the last picture - the slider's own bottom space -
         and anchoring to it left a thin white band between the photo and the
         line. Measured, because that space is the theme's and not a number
         this file can be told. */
      /* The SMALLEST gap, not the largest: with photos of different heights it
         is the tallest one that sets where the pictures visually end, and that
         is the edge the line belongs on. */
      var below = null, k;
      for (k = 0; k < items.length; k++) {
        if (!items[k].getClientRects().length) continue;
        var ir = items[k].getBoundingClientRect();
        if (ir.width < 40) continue;
        var g = host.bottom - ir.bottom;
        if (below === null || g < below) below = g;
      }
      track.style.bottom = (below !== null && below > 0 && below < 80 ? below : 0) + 'px';
      /* The photo, not the frame - and the photo AT REST, not the one
         currently snapped.

         The strip lets the next picture peek past the right edge, so matching
         the frame would run the line out under the peek. But reading whichever
         photo is snapped moves the line: the strip is pulled out to the screen
         edges with a negative margin and puts the page's gutter back inside as
         padding, so after a swipe the snapped photo sits against the frame and
         the line would slide out from under the trust bar directly beneath it.

         Taking the first picture's box back to scroll position 0 gives the
         edge the pictures occupy at rest - which is where the bar and the
         product title sit - and gives the same answer at every scroll
         position. */
      var first = null, i;
      for (i = 0; i < items.length; i++) {
        if (!items[i].getClientRects().length) continue;
        if (items[i].getBoundingClientRect().width < 40) continue;
        first = items[i];
        break;
      }
      var shot = first ? first.getBoundingClientRect() : frame;
      var sx = first ? (slider.scrollLeft || 0) : 0;
      var l = (shot.left + sx) - host.left;
      var rr = host.right - (shot.right + sx);
      /* Negatives are allowed on purpose. The photo strip carries negative
         margins on a phone and runs wider than the viewer the track lives in,
         so reaching the picture's edges means pulling OUTWARD - clamping at
         zero left the line short of the photos on both sides. */
      track.style.left = (l > -200 && l < 200 ? l : 0) + 'px';
      track.style.right = (rr > -200 && rr < 200 ? rr : 0) + 'px';
    }
    fitTrack();
    window.addEventListener('resize', fitTrack);
    window.addEventListener('load', fitTrack);
    try { new ResizeObserver(fitTrack).observe(viewer); } catch (err) {}

    var queued = false;
    function draw() {
      fitTrack();
      queued = false;
      var n = 0, i;
      for (i = 0; i < items.length; i++) {
        if (items[i].offsetParent !== null || items[i].getClientRects().length) n++;
      }
      if (n < 2) return;
      seg.style.width = (100 / n) + '%';
      var max = slider.scrollWidth - slider.clientWidth;
      var p = max > 8 ? slider.scrollLeft / max : 0;
      /* translateX in % is a share of the SEGMENT's own width, and the
         segment travels its own width n-1 times to cross the track. */
      seg.style.transform = 'translateX(' + (p * (n - 1) * 100) + '%)';
    }
    function queue() { if (queued) return; queued = true; requestAnimationFrame(draw); }

    slider.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    try { new ResizeObserver(queue).observe(slider); } catch (err) {}
    draw();
    return true;
  }

  /* The rail lives in the gutter, i.e. outside the gallery box. If anything
     between here and the grid clips, it vanishes. Only ever relaxes an
     overflow that was already hidden, and only three levels up. */
  function unclip(el) {
    var n = el.parentElement, i = 0;
    while (n && i < 3) {
      var o = getComputedStyle(n);
      if (o.overflowX === 'hidden' || o.overflow === 'hidden') n.style.overflow = 'visible';
      n = n.parentElement; i++;
    }
  }

  /* ---------------------------------------------------------------- *
   * Boot. Same shape as v2-groups: the gallery may parse after us.    *
   * ---------------------------------------------------------------- */
  function run() {

    /* Page-level guard. Without it this file's only protection is "it is
       only rendered on the v2 template" - true today, but it would quietly
       restyle the live gallery the moment a render tag landed in a shared
       section. The v2 buy box must be on the page before a single thumbnail
       is touched. Widen this selector if the dots are ever wanted alone.

       Returns false, not true: this file can be parsed before the buy box
       exists, so a missing marker means "not yet", not "never". The retry
       loop gives up on its own after three seconds, having written nothing. */
    if (!document.querySelector('.v2-pdp, [data-v2-groups]')) return false;

    var gs = document.querySelectorAll('media-gallery');
    if (!gs.length) return false;
    var wide = window.matchMedia(MQ).matches;
    var done = true;
    for (var i = 0; i < gs.length; i++) {
      if (!progress(gs[i])) done = false;
      if (wide && !attach(gs[i])) done = false;
    }
    return done;
  }

  if (!run()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    window.addEventListener('load', run);
    var tries = 0;
    var iv = setInterval(function () { if (run() || ++tries > 60) clearInterval(iv); }, 50);
  }

  /* ---------- hold the last photo at the bottom ---------- */
  var DOTCFG = document.querySelector('[data-v2-dots-cfg]');
  var HOLD = DOTCFG ? DOTCFG.getAttribute('data-hold-last') === 'true' : false;
  var HOLD_GAP = DOTCFG ? (parseFloat(DOTCFG.getAttribute('data-hold-gap')) || 0) : 0;

  /* BOTH columns, not just the gallery.

     Whichever one runs out first should wait for the other, and which one
     that is depends entirely on the product: a piece with eight photos and a
     short buy column runs out on the right, one with three photos and a full
     set of 03/04/05 runs out on the left. Holding only the gallery fixed half
     the products and left the other half exactly as they were - the photos
     still scrolling on alone after the column had finished.

     Applying it to both needs no decision about which is which. The shorter
     column reaches its end, parks, and waits; the taller one keeps scrolling
     until it catches up; they finish together. On the taller column the same
     rule is simply never reached before the page ends, so it costs nothing. */
  /* How much of the top of the screen the theme's header is already using.
     The park position is measured from the top of the VIEWPORT, but the top
     of the viewport is not the top of the page you can see - a sticky header
     sits over it. Parking at the gap alone tucked the first photo underneath
     the header and left it there, which is what "it stops at the first
     picture" was. Measured, not assumed: a header that scrolls away with the
     page is not sticky and costs nothing. */
  function headerOffset() {
    var els = document.querySelectorAll(
      'sticky-header, .shopify-section-header-sticky, .section-header, .header-wrapper, header');
    var most = 0;
    for (var i = 0; i < els.length; i++) {
      var cs = getComputedStyle(els[i]);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      var r = els[i].getBoundingClientRect();
      if (r.height > most && r.height < window.innerHeight / 2) most = r.height;
    }
    return Math.round(most);
  }

  /* Declared before holdColumn fills them. Left below, the var would run
     after the first holdColumn() call and empty the list again. */
  var HELD = [];
  var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;

  function holdColumn() {
    if (!HOLD) return;
    if (!document.querySelector('.v2-pdp, [data-v2-groups]')) return;
    var g = document.querySelector('media-gallery:not([id*="-duplicate"])');
    if (!g) return;

    var cols = [];
    var media = g.closest('.product__media-wrapper') || g.parentElement;
    if (media) cols.push(media);
    var info = document.querySelector('[data-v2-groups]');
    info = info && (info.closest('.product__info-wrapper') || info.closest('.product__info-container'));
    if (info && info !== media) cols.push(info);

    var wide = window.matchMedia(MQ).matches;
    var vh = window.innerHeight;
    var head = headerOffset();
    HELD = [];
    for (var i = 0; i < cols.length; i++) {
      var col = cols[i];
      if (!wide) {
        col.removeAttribute('data-v2-hold');
        col.style.top = '';
        continue;
      }
      col.setAttribute('data-v2-hold', '');
      /* Measure the column, not its contents: the trust bar sits inside the
         gallery and any margin around it counts toward what has to clear the
         screen before the hold begins. */
      var h = col.getBoundingClientRect().height;
      /* Two stops, one at each end.

         BOTTOM, measured from the bottom of the screen: park the column's
         bottom edge HOLD_GAP above it. sticky only understands top, so that
         is written as viewport - height - gap, which comes out negative
         whenever the column is taller than the screen. That is where a column
         waits on the way down.

         TOP, measured from below the header - not from the top of the
         viewport. The top of the viewport is not the top of the page you can
         see; a sticky header sits over it. Parking at the gap alone tucked
         the first thing in the column underneath the header and left it
         there, which is why coming back up looked like it stopped short. */
      var minTop = Math.round(vh - h - HOLD_GAP);   /* pinned at the bottom */
      var maxTop = head + HOLD_GAP;                 /* pinned below the header */
      var short = h + HOLD_GAP + head <= vh;        /* fits: never needs to slide */
      /* Keep where it already is if this is a re-measure mid-page, so opening
         a Details row does not throw the column back to one end. */
      var was = parseFloat(col.style.top);
      var top = isNaN(was) ? (short ? maxTop : minTop)
                           : Math.min(maxTop, Math.max(minTop, was));
      if (short) top = maxTop;
      col.style.top = Math.round(top) + 'px';
      HELD.push({ el: col, h: h, minTop: minTop, maxTop: maxTop, short: short, top: top });
    }
  }

  /* ---------- and the same going back up ----------
     position:sticky can pin one edge, not both. Given an element taller than
     the screen, top and bottom are contradictory instructions and the browser
     honours top - so scrolling down held correctly and scrolling up let the
     shorter column slide away while the taller one was still moving, which is
     the same gap as before, just at the other end.

     So the offset is driven instead of declared: it accumulates against the
     scroll and is clamped between the two pinned positions. Scroll down and
     it runs to the bottom stop; scroll up and it runs back to the top one.
     Reverse direction halfway and it starts back from where it is rather than
     jumping, which is what makes it feel attached to the page.

     Heights are read in holdColumn and cached, never here - measuring inside
     a scroll handler forces layout on every frame and the column visibly lags
     behind the cursor. This only does arithmetic. */
  function onHoldScroll() {
    if (!HELD.length) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var delta = y - lastY;
    lastY = y;
    if (!delta) return;
    for (var i = 0; i < HELD.length; i++) {
      var c = HELD[i];
      var next = c.short ? c.maxTop : Math.min(c.maxTop, Math.max(c.minTop, c.top - delta));
      if (next !== c.top) {
        c.top = next;
        c.el.style.top = Math.round(next) + 'px';
      }
    }
  }
  window.addEventListener('scroll', onHoldScroll, { passive: true });

  var holdT;
  function queueHold() { clearTimeout(holdT); holdT = setTimeout(holdColumn, 80); }
  window.addEventListener('resize', queueHold);
  window.addEventListener('load', holdColumn);
  /* Photos arrive at their real height only once they load, and the trust
     bar is added a beat later - both change the number this depends on. */
  try {
    var g0 = document.querySelector('media-gallery:not([id*="-duplicate"])');
    if (g0) new ResizeObserver(queueHold).observe(g0);
    /* The buy column changes height on its own - opening a Details row,
       revealing the extra FAQ chips - and each of those moves where it
       should park. */
    var i0 = document.querySelector('[data-v2-groups]');
    i0 = i0 && (i0.closest('.product__info-wrapper') || i0.closest('.product__info-container'));
    if (i0) new ResizeObserver(queueHold).observe(i0);
  } catch (err) {}
  holdColumn();
  setTimeout(holdColumn, 400);
  setTimeout(holdColumn, 1500);

  /* Resizing past the breakpoint from mobile builds the rail on first cross. */
  try {
    window.matchMedia(MQ).addEventListener('change', function (e) { if (e.matches) run(); holdColumn(); });
  } catch (err) { /* Safari < 14 */ }
}());
}
v2run();
if (window.Shopify && window.Shopify.designMode) {
document.addEventListener('shopify:section:load', function () { try { v2run(); } catch (e) {} });
}
})();
